module.exports = __webpack_public_path__ + "static/media/2.c8514654.jpg";